// extracted by mini-css-extract-plugin
export default {"container":"ImagePreview_container__M0BDe","imageBox":"ImagePreview_imageBox__Vn3w5","image":"ImagePreview_image__BCo2W","deleteWrap":"ImagePreview_deleteWrap__I5+Si"};